import React from 'react';

import dasboardPng from '../../../assets/logos/pie-chart.png';

import patientsPng from '../../../assets/logos/patient.png';

import calenderPng from '../../../assets/logos/calendar.png';

import hospitalPng from '../../../assets/logos/hospital.png';

import chatPng from '../../../assets/logos/chats.png';

import reportsPng from '../../../assets/logos/reportsPng.png';

import { Chip } from '@mui/material';

import {
	DashboardRounded as DashboardRoundedIcon,
	PersonPinCircleRounded as PersonPinCircleRoundedIcon,
	AssessmentRounded as AssessmentRoundedIcon,
	PeopleRounded as PeopleRoundedIcon,
	AccessibleRounded as AccessibleRoundedIcon,
	SupervisedUserCircleRounded as SupervisedUserCircleRoundedIcon,
	NotificationsRounded as NotificationsRoundIcon,
	AccountBoxRounded as AccountBoxRoundedIcon,
	StoreRounded as StoreRoundedIcon,
	ExitToAppRounded as ExitToAppRoundedIcon,
	GroupWork as GroupWorkIcon,
	Widgets as DashboardRoundedIconTwo,
	CalendarMonthRounded as CalendarMonthRoundedIcon,
	AnalyticsRounded as AnalyticsRoundedIcon,
} from '@mui/icons-material';
export const sideBarData = [
	{
		text: 'Dashboard',
		path: '/dashboard',
		icon: (
			<DashboardRoundedIconTwo style={{ display: 'flex', color: '#fff' }} />
		),
		chip: null,
	},
	{
		text: 'Patients',
		path: '/patient_list',
		icon: <PeopleRoundedIcon style={{ display: 'flex', color: '#fff' }} />,
		chip: (
			<Chip
				label="90"
				sx={{
					display: open ? 'flex' : 'none',
					color: 'white',
					fontWeight: 400,
					fontSize: '12px',
					fontFamily: 'monospace',
					width: '44px',
					height: '24px',
					backgroundColor: '#CFCFCF',
				}}
			/>
		),
	},
	{
		text: 'Charges',
		path: '/charges',
		icon: (
			<PersonPinCircleRoundedIcon style={{ display: 'flex', color: '#fff' }} />
		),
		chip: null,
	},
	{
		text: 'Batches',
		path: '/batches',
		icon: <AnalyticsRoundedIcon style={{ display: 'flex', color: '#fff' }} />,
		chip: null,
	},
	{
		text: 'Schedular',
		path: '/schedular',
		icon: (
			<CalendarMonthRoundedIcon style={{ display: 'flex', color: '#fff' }} />
		),
		chip: null,
	},
	// {
	//     text:'Messages',
	//     path:'/messages',
	//     icon:<img src={chatPng} width={'20px'} />,
	//     chip:<Chip
	//     label="20"
	//     sx={{

	//         color: 'white',
	//         fontSize: '12px',
	//         fontFamily:'monospace',
	//         width: '44px',
	//         height: '24px',
	//         backgroundColor: '#CFCFCF',
	//     }}
	// />,

	// },
	{
		text: 'Reports',
		path: '/reports',
		icon: <AssessmentRoundedIcon style={{ display: 'flex', color: '#fff' }} />,
		chip: null,
	},
	{
		text: 'Missed Charge Finder',
		path: '/missed_charge_finder',
		icon: <GroupWorkIcon style={{ display: 'flex', color: '#fff' }} />,
		chip: null,
	},
];
